


































































































































































import Component, { mixins } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import TextDayChangePicker from "@/components/common/TextDayChangePicker.vue";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import MonthMultiplePicker from "@/components/common/MonthMultiplePicker.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import BaseTable, {
  StringKeyObject
} from "@/components/common/MergeBaseTable.vue";
import RightSideMenu from "@/components/common/RightSideMenu.vue";
import RadioGroupDialog from "@/components/common/RadioGroupDialog.vue";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import { HeaderWidthItem, ObjectId } from "@/types";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import {
  YearmonthsState,
  SET_YEARMONTHS
} from "@/store/modules/yearmonths/types";
import { getStorageBoolean, getStorageNumber, dateJp } from "@/types";
import { AxiosResponse } from "axios";
import SelectFilter, { ColumnKey } from "@/components/common/SelectFilter.vue";
import { yearmonth } from "@/store/modules/yearmonth";
import ReCalcResultDialog from "@/components/common/ReCalcResultDialog.vue";
import MonthPickerDialog from "@/components/common/MonthPickerDialog.vue";
import SelectDialog from "@/components/common/SelectDialog.vue";
import { getDefaultMonth } from "@/types";
import DayPickerDialog from "@/components/common/DayPickerDialog.vue";

const StoreYearmonth = namespace("yearmonth");
const StoreYearmonths = namespace("yearmonths");

@Component({
  components: {
    TextDayChangePicker,
    TextMonthChangePicker,
    MonthMultiplePicker,
    BaseTable,
    LoadingDialog,
    RightSideMenu,
    RadioGroupDialog,
    SelectFilter,
    ReCalcResultDialog,
    MonthPickerDialog,
    SelectDialog,
    DayPickerDialog
  }
})
export default class MedicalMerge extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;
  @Ref("previewTypeDialog")
  private readonly previewTypeDialog!: RadioGroupDialog;
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;

  @State("yearmonths") yearmonthsState!: YearmonthsState;
  @StoreYearmonths.Mutation(SET_YEARMONTHS) setYearmonths!: Function;
  private get storeYearmonths() {
    return this.yearmonthsState.yearmonths;
  }
  private set storeYearmonths(yearmonths: string[]) {
    localStorage.setItem("yearmonths", JSON.stringify(this.yearmonths));
    this.setYearmonths(yearmonths);
  }
  private yearmonths: string[] = [];

  @Ref("reCalcReCalcResultDialog")
  private readonly reCalcReCalcResultDialog!: ReCalcResultDialog;

  SPECIFICATION = 0;
  INVOICE = 1;
  MERGE = 2;
  private objectIdsBK: ObjectId[] = [];
  private CheckedOn = false;
  private downLoad = false;
  private searchYM = "";
  private useMultiMonth = "";
  private isActiveMonthPicker = false;
  private isActiveDayPicker = false;
  private type = 0;

  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  private historys = [];
  private isActiveHistory = false;
  private selectHistory: { id: number; updated_at?: string } = {
    id: 0
  };
  private historyPatient: { id: number; name: string } = { id: 0, name: "" };

  private headerItems: HeaderWidthItem[] = [
    {
      value: "edit",
      text: "編集",
      width: "80px"
    },
    {
      value: "history",
      text: "履歴",
      width: "80px"
    },
    {
      value: "is_printed",
      text: "明細データ確定済日",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_printed", val)
    },
    {
      value: "is_exec",
      text: "処理済日",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_exec", val)
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px",
      filter: (val: object) => this.columnFilter("insured_no", val)
    },
    {
      value: "name",
      text: "氏名",
      width: "120px",
      filter: (val: object) => this.columnFilter("name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "120px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_no", val)
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "140px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_name", val)
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "108px"
    }
  ];

  private multiMonthHeaderItems: HeaderWidthItem[] = [
    {
      value: "edit",
      text: "編集",
      width: "80px"
    },
    {
      value: "history",
      text: "履歴",
      width: "80px"
    },
    {
      value: "is_printed",
      text: "明細データ確定済日",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_printed", val)
    },
    {
      value: "is_exec",
      text: "処理済日",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_exec", val)
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px",
      filter: (val: object) => this.columnFilter("insured_no", val)
    },
    {
      value: "name",
      text: "氏名",
      width: "120px",
      filter: (val: object) => this.columnFilter("name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "120px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_no", val)
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "140px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_name", val)
    },
    {
      value: "disp_yearmonth",
      text: "サービス提供年月",
      width: "108px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("disp_yearmonth", val)
    }
  ];

  // 請求方法情報map
  // Key:yearmonth Value:method_div
  private invMethodMap: Map<string, number> = new Map();

  //------------------------------------------
  // 検索メッセージの表示有無
  //------------------------------------------
  private get searchMessage(): string {
    //検索年月に新請求方法の年月が含まれる場合はメッセージを表示する
    if (this.dispYearmonths.length > 0) {
      return (
        "下記年月は「医療請求管理 (新：電子/紙)」から請求する設定になっています。</br>ご確認の上、操作を進めてください。</br>" +
        "(" +
        this.dispYearmonths +
        ")"
      );
    }
    return "";
  }

  // 検索メッセージ表示用の年月
  private get dispYearmonths(): string {
    let dispYearmonths = "";
    if (this.useMultiMonth == "0") {
      //単年月検索の場合
      if (
        this.invMethodMap.has(this.yearmonth.replace("-", "")) &&
        this.invMethodMap.get(this.yearmonth.replace("-", "")) == 1
      ) {
        dispYearmonths = `${this.yearmonth.split("-")[0]}年${
          this.yearmonth.split("-")[1]
        }月`;
      }
    }
    if (this.useMultiMonth == "1") {
      //複数年月の場合
      for (const ym of this.yearmonths) {
        if (
          this.invMethodMap.has(ym.replace("-", "")) &&
          this.invMethodMap.get(ym.replace("-", "")) == 1
        ) {
          dispYearmonths +=
            (dispYearmonths.length > 0 ? "、" : "") +
            `${ym.split("-")[0]}年${ym.split("-")[1]}月`;
        }
      }
    }
    return dispYearmonths;
  }

  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    return this.headerItems
      .filter(hditm => {
        return hditm.filter != null;
      })
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          //選択肢一覧作成
          selectable = this.tableItems
            .map(itm => {
              const txt = (itm as any)[hditm.value];
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          //NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });
  }

  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);

    // テーブル更新
    if (this.baseTable) {
      this.baseTable.handle();
    }
    return bret;
  }

  private tableItems: object[] = [];

  private noExecs: object[] = []; //未処理データ
  private noExecCount = 0; //未処理件数
  private invoiceYMD: string = dateJp(new Date()).substr(0, 10); //請求書日付
  private message = ""; //メッセージ

  mounted() {
    this.yearmonths =
      JSON.parse(String(localStorage.getItem("yearmonths"))) ||
      this.storeYearmonths;
    // 画面復帰設定（チェックボックス、フィルタ条件）
    if (!this.$route.query.st) {
      this.baseTable.clearAllCheck();
      this.selectFilter.clearAll();
    } else {
      this.baseTable.restoreStorage();
      this.selectFilter.restoreStorage();
    }
    // 請求方法データの取得
    this.initInvoiceMethods();
    // 画面更新
    this.updateData();
  }

  // 請求方法データの取得
  private initInvoiceMethods() {
    this.postJsonCheckFailWithNoLoading(
      window.base_url + "/api/office/setting/invoicemethod/get",
      {},
      res => {
        for (const invMethod of res.data.invoice_methods) {
          this.invMethodMap.set(invMethod.yearmonth, invMethod.method_div);
        }
      },
      () => {
        // 202406~202412の請求方法のデフォルトは旧
        for (let month = 6; month <= 12; month++) {
          this.invMethodMap.set("2024" + String(month).padStart(2, "0"), 0);
        }
      }
    );
  }

  //------------------------------------------
  //データ更新
  //------------------------------------------
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/specification/get",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        yearmonths: this.yearmonths.map(yearmonth => yearmonth.replace("-", ""))
      },
      res => {
        this.searchYM = this.yearmonth.replace("-", ""); // 検索年月保持(Excelファイル名に使用)
        this.tableItems = res.data.specifications;
        this.noExecs = res.data.no_outputs;
        this.noExecCount = res.data.count;
        this.useMultiMonth = res.data.use_multi_month;
        if (this.useMultiMonth == "1") {
          // 複数月まとめ出力利用する場合はサービス提供年月をフィルタ可能にする
          this.headerItems = this.multiMonthHeaderItems;
        }
        this.$router.replace(`/medical/merge?st=1`).catch(err => err);
        this.$nextTick(() => {
          this.baseTable.restoreStorage();
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  //------------------------------------------
  //検索
  //------------------------------------------
  private search() {
    this.storeYearmonths = this.yearmonths;
    this.baseTable.clearAllCheck();
    this.updateData();
  }

  //------------------------------------------
  //再集計
  //------------------------------------------
  private closeMonthPicker() {
    this.isActiveMonthPicker = false;
  }
  private cleckReCalc(object: ObjectId[]) {
    if (object.length == 0) {
      this.isActiveMonthPicker = true;
    } else {
      this.reCalc(object);
    }
  }
  private reCalcResultReload() {
    this.storeYearmonths = this.yearmonths;
    this.updateData();
  }

  private reCalcAll(yearmonth: string) {
    //確認
    if (
      !confirm(
        "対象年月の確定済かつ請求履歴未確定データを再集計します。" +
          "\n" +
          "また、編集したデータはリセットされ最新の状態に更新されます。" +
          "\n" +
          "よろしいですか？"
      )
    ) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/recalc/result",
      {
        ins_type: 1,
        all: true,
        multi_month: false,
        yearmonth: yearmonth,
        yearmonths: [],
        select_items: []
      },
      res => {
        this.message = res.data.result_message;
        this.isActiveMonthPicker = false;
        this.reCalcReCalcResultDialog.open();
        this.baseTable.selectItems = this.baseTable.items;
      }
    );
  }
  private reCalc(object: ObjectId[]) {
    //確認
    if (
      !confirm(
        "選択されたデータを再集計します。" +
          "\n" +
          "また、編集したデータはリセットされ最新の状態に更新されます。" +
          "\n" +
          "よろしいですか？"
      )
    ) {
      return;
    }
    //複数月チェック
    const result = this.multiMonthCheck(object);
    this.postJsonCheck(
      window.base_url + "/api/office/recalc/result",
      {
        ins_type: 1,
        all: false,
        multi_month: result.result,
        yearmonth: result.yearmonth,
        yearmonths: result.yearmonths,
        select_items: object
      },
      res => {
        this.message = res.data.result_message;
        this.reCalcReCalcResultDialog.open();
      }
    );
  }
  private get Message() {
    return this.message;
  }

  private multiMonthCheck(object: ObjectId[]) {
    let result = false;
    const yearmonth = object[0].yearmonth;
    const yearmonths: string[] = [yearmonth];
    for (const o of object) {
      let pushFlg = true;
      if (yearmonth != o.yearmonth) {
        result = true;
      }
      for (const y of yearmonths) {
        if (y == o.yearmonth) {
          pushFlg = false;
        }
      }
      if (pushFlg) {
        yearmonths.push(o.yearmonth);
      }
    }
    return { result: result, yearmonth: yearmonth, yearmonths: yearmonths } as {
      result: boolean;
      yearmonth: string;
      yearmonths: string[];
    };
  }

  //------------------------------------------
  //結果ダウンロード
  //------------------------------------------
  private downloadResult() {
    this.postJsonBlobResCheck(
      window.base_url + "/api/office/recalc/downloadResult",
      {
        message: this.message
      },
      res => {
        const fileName = "downloadReCalcResult.txt";
        this.downloadMessageTxt(res.data, fileName);
      }
    );
  }
  private downloadMessageTxt(blobable: Blob, fileName: string): void {
    if (!blobable.size) return;
    const blob = new Blob([blobable]);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.click();
  }

  //------------------------------------------
  //明細書出力
  //------------------------------------------
  private doneSpecification(
    objectIds: ObjectId[],
    isPrevew = false,
    date = ""
  ) {
    const isSamePrint = getStorageBoolean("isSamePrint", false);
    const isShahoRatioPrint = getStorageBoolean("isShahoRatioPrint", false);
    const isNengoPrint = getStorageBoolean("isNengoPrint", false);
    if (this.useMultiMonth == "0") {
      // 複数月まとめ出力機能利用しない場合現在の対象年月をセット
      this.yearmonths = [this.yearmonth];
    }

    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/specification",
      {
        yearmonths: this.yearmonths,
        ids: objectIds.map(objectId => objectId.id),
        is_same_print: isSamePrint,
        is_shaho_ratio_print: isShahoRatioPrint,
        is_nengo_print: isNengoPrint,
        is_preview: isPrevew,
        patients: objectIds.map(objectId => ({
          id: objectId.patient_id,
          name: objectId.name
        }))
      },
      res => {
        //最終出力処理で処理済みする場合
        if (this.CheckedOn) {
          this.checked(this.objectIdsBK, date);
          this.execChecked(this.objectIdsBK, date);
          this.CheckedOn = false;
        }
        if (this.downLoad) {
          this.dwonLoadPDF(res.data.pdf_path, "明細書");
        } else {
          window.open(res.data.pdf_path);
        }
        this.downLoad = false;
      }
    );
  }

  //------------------------------------------
  //請求書出力
  //------------------------------------------
  private doneInsinvoice(objectIds: ObjectId[], isPreview = false, date = "") {
    if (this.useMultiMonth == "0") {
      // 複数月まとめ出力機能利用しない場合現在の対象年月をセット
      this.yearmonths = [this.yearmonth];
    }
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/insinvoice",
      {
        yearmonths: this.yearmonths,
        ids: objectIds.map(objectId => objectId.id),
        invoice_date: this.invoiceYMD,
        is_preview: isPreview,
        patients: objectIds.map(objectId => ({
          id: objectId.patient_id,
          name: objectId.name
        }))
      },
      res => {
        //最終出力処理で処理済みする場合
        if (this.CheckedOn) {
          this.checked(this.objectIdsBK, date);
          this.execChecked(this.objectIdsBK, date);
          this.CheckedOn = false;
        }
        if (this.downLoad) {
          this.dwonLoadPDF(res.data.pdf_path, "請求書");
        } else {
          window.open(res.data.pdf_path);
        }
        this.downLoad = false;
      }
    );
  }

  //------------------------------------------
  //明細書・請求書出力
  //------------------------------------------
  private doneAll(objectIds: ObjectId[], isPreview = false, date = "") {
    const isSamePrint = getStorageBoolean("isSamePrint", false);
    const isShahoRatioPrint = getStorageBoolean("isShahoRatioPrint", false);
    const isNengoPrint = getStorageBoolean("isNengoPrint", false);
    if (this.useMultiMonth == "0") {
      // 複数月まとめ出力機能利用しない場合現在の対象年月をセット
      this.yearmonths = [this.yearmonth];
    }
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/all",
      {
        yearmonths: this.yearmonths,
        ids: objectIds.map(objectId => objectId.id),
        invoice_date: this.invoiceYMD,
        is_same_print: isSamePrint,
        is_shaho_ratio_print: isShahoRatioPrint,
        is_nengo_print: isNengoPrint,
        is_preview: isPreview,
        patients: objectIds.map(objectId => ({
          id: objectId.patient_id,
          name: objectId.name
        }))
      },
      res => {
        //最終出力処理で処理済みする場合
        if (this.CheckedOn) {
          this.checked(this.objectIdsBK, date);
          this.execChecked(this.objectIdsBK, date);
          this.CheckedOn = false;
        }
        if (this.downLoad) {
          this.dwonLoadPDF(res.data.pdf_path, "明細書・請求書");
        } else {
          window.open(res.data.pdf_path);
        }
        this.downLoad = false;
      }
    );
  }

  //------------------------------------------
  //明細データ確定
  //------------------------------------------
  private async checked(objectIds: ObjectId[], date: string) {
    if (!date) {
      date = this.Today;
    }

    // 対象年月に新請求方法が含まれる場合、処理ブロック
    if (this.dispYearmonths.length > 0) {
      await alert(`下記年月は「医療請求管理 (新：電子/紙)」から請求する設定になっています。
明細データ確定を行う場合は「医療請求管理 (新：電子/紙)」をご利用ください。
(${this.dispYearmonths})`);
      return;
    }

    const ids = objectIds.map(item => item.id);
    this.postJsonCheck(
      window.base_url + "/api/office/medical/specification/checked",
      {
        ids: ids,
        date: date,
        patients: objectIds.map(item => ({
          id: item.patient_id,
          name: item.name
        }))
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  //処理済み日確定
  //------------------------------------------
  private execChecked(objectIds: ObjectId[], date: string) {
    if (!date) {
      date = this.Today;
    }

    const ids = objectIds.map(item => item.id);
    this.postJsonCheck(
      window.base_url + "/api/office/medical/insinvoice/checked",
      {
        ids: ids,
        date: date,
        patients: objectIds.map(item => ({
          id: item.patient_id,
          name: item.name
        }))
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  //取消
  //------------------------------------------
  private async cancel(objectIds: ObjectId[]) {
    // 対象年月に新請求方法が含まれる場合、処理ブロック
    if (this.dispYearmonths.length > 0) {
      await alert(`下記年月は「医療請求管理 (新：電子/紙)」から請求する設定になっています。
明細データ確定の取消を行う場合は「医療請求管理 (新：電子/紙)」をご利用ください。
(${this.dispYearmonths})`);
      return;
    }

    const ids = objectIds.map(item => item.id);

    this.postJsonCheck(
      window.base_url + "/api/office/medical/specification/cancel",
      {
        ids: ids,
        patients: objectIds.map(item => ({
          id: item.patient_id,
          name: item.name
        }))
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  //ダウンロード
  //------------------------------------------
  private async download(objectIds: ObjectId[]) {
    // 対象年月に新請求方法が含まれる場合、アラートを出す
    if (this.dispYearmonths.length > 0) {
      await alert(
        "「医療請求管理 (旧：紙)」にある明細書の詳細が出力されます。\n「医療請求管理 (新：電子/紙)」で編集を行っても、この帳票には反映されません。"
      );
    }

    const ids = objectIds.map(item => item.id);
    const param = {
      yearmonth: this.searchYM,
      ids: ids,
      patients: objectIds.map(item => ({
        id: item.patient_id,
        name: item.name
      }))
    };
    const yy = this.yearmonth.split("-")[0];
    const mm = this.yearmonth.split("-")[1];
    const fname = `明細書詳細_${this.dateFormat(new Date())}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/medical/specification/excel",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  // 日付フォーマット(yyyyMMdd_HHmmss)
  private dateFormat(d: Date) {
    const ymd = `${d.getFullYear()}${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${d
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    const hms = `${d
      .getHours()
      .toString()
      .padStart(2, "0")}${d
      .getMinutes()
      .toString()
      .padStart(2, "0")}${d
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
    return `${ymd}_${hms}`;
  }

  //------------------------------------------
  //編集画面に遷移
  //------------------------------------------
  private async edit(item: ObjectId) {
    // サービス提供年月の請求方法が新の場合、アラートを出す
    if (
      this.invMethodMap.has(item.yearmonth.replace("-", "")) &&
      this.invMethodMap.get(item.yearmonth.replace("-", "")) == 1
    ) {
      await alert(
        "こちらで編集を行っても、「医療請求管理 (新：電子/紙)」には反映されません。"
      );
    }

    this.$router.push({
      path:
        "/medical/edit/" +
        item.patient_id +
        "?tab=specification&specification_id=" +
        item.id +
        "&yearmonth=" +
        item.yearmonth.replace("-", "") +
        "&patient_name=" +
        encodeURIComponent(item.name)
    });
  }

  //------------------------------------------
  //履歴取得する
  //------------------------------------------
  private history(item: StringKeyObject) {
    this.historyPatient = {
      id: (item.patient_id as unknown) as number,
      name: (item.name as unknown) as string
    };
    this.postJsonCheck(
      window.base_url + "/api/office/medical/specification/get_historys",
      {
        patient_id: item.patient_id,
        patient_name: item.name,
        yearmonth: String(item.yearmonth).replace("-", ""),
        insurance_type: item.insurance_type,
        insurance_no: item.insurance_no,
        insurance_div: item.insurance_div
      },
      res => {
        this.historys = res.data.historys;
        this.isActiveHistory = true;
      }
    );
  }

  private get OnChangeHistory() {
    return this.historys;
  }

  private onSelecHistory(item: { id: number; updated_at: string }) {
    this.selectHistory = item;
    this.isActiveHistory = false;
    this.historyPdf(item);
  }

  private onCancelHistory() {
    this.isActiveHistory = false;
  }

  //------------------------------------------
  //履歴用PDF出力
  //------------------------------------------
  private historyPdf(item: { id: number; updated_at: string }) {
    const isSamePrint = getStorageBoolean("isSamePrint", false);
    const isShahoRatioPrint = getStorageBoolean("isShahoRatioPrint", false);
    const isNengoPrint = getStorageBoolean("isNengoPrint", false);
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/specification",
      {
        ids: [item.id],
        is_same_print: isSamePrint,
        is_shaho_ratio_print: isShahoRatioPrint,
        is_nengo_print: isNengoPrint,
        history: 1,
        patients: [this.historyPatient]
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  //------------------------------------------
  //最終出力処理
  //------------------------------------------
  private async output(objectIds: ObjectId[]) {
    // 対象年月に新請求方法が含まれる場合、処理ブロック
    if (this.dispYearmonths.length > 0) {
      await alert(`下記年月は「医療請求管理 (新：電子/紙)」から請求する設定になっています。
出力紙レセプトを行う場合は「医療請求管理 (新：電子/紙)」をご利用ください。
(${this.dispYearmonths})`);
      return;
    }

    this.objectIdsBK = objectIds;
    this.downLoad = true;
    const type = getStorageNumber("mediinv-print-type");
    this.previewTypeDialog.open(type);
  }

  //最終出力処理(出力タイプ選択)
  private done(type: number) {
    localStorage.setItem("mediinv-print-type", type.toString());
    //処理済み設定
    this.CheckedOn = false;
    if (confirm("処理済みにしますか？")) {
      this.isActiveDayPicker = true;
      this.type = type;
      return;
    }
    this.doneExec(type, "");
  }

  private doneExec(type: number, date: string) {
    //PDF作成
    switch (type) {
      case this.SPECIFICATION:
        this.doneSpecification(this.objectIdsBK, false, date);
        break;
      case this.INVOICE:
        this.doneInsinvoice(this.objectIdsBK, false, date);
        break;
      case this.MERGE:
        this.doneAll(this.objectIdsBK, false, date);
        break;
    }
  }

  private changeYear(yearmonth: string) {
    if (this.useMultiMonth == "1") {
      if (this.yearmonths.indexOf(yearmonth) == -1) {
        this.yearmonths.push(yearmonth);
      }
    } else {
      this.yearmonth = yearmonth;
    }
    this.updateData();
  }

  //------------------------------------------
  //PDFダウンロード
  //------------------------------------------
  private dwonLoadPDF(url: string, typename: string) {
    this.loading = true;
    window.axios
      .get(url, {
        responseType: "blob"
      })
      .then((response: AxiosResponse) => {
        const blob = new Blob([response.data]);
        const a = document.createElement("a");
        a.download = `医療-${typename}.pdf`;
        a.href = URL.createObjectURL(blob);
        a.click();
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        alert("サーバでエラーが発生しました。");
        console.log(error);
        console.log(error.response);
      });
  }

  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }

  // 処理済み日設定ダイアログを閉じる
  private closeDayPicker() {
    this.isActiveDayPicker = false;
  }

  // 処理済み日設定ダイアログで日付を設定する
  private selectDay(date: string) {
    //PDF作成
    this.CheckedOn = true;
    this.doneExec(this.type, date);
    this.closeDayPicker();
  }

  //リアルタイム今日
  private get Today(): string {
    const date = new Date();
    date.setTime(date.getTime() + 1000 * 60 * 60 * 9);
    date.setDate(date.getDate());
    const today = date.toISOString().substr(0, 10);
    return today;
  }
}
